import {BaseOptions} from "../../options/base.options";

export class TooManyRequestOptions extends BaseOptions {
  onResolved = () => {
  };
}
